/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestCurveSwaps extends Contract<ITestCurveSwaps> {
  get_best_rate: Call<(_from: AddressLike, _to: AddressLike, _amount: BigNumberish) => { bestPool_: string, amountReceived_: BigNumber }, ITestCurveSwaps>
  'get_best_rate(address,address,uint256)': Call<(_from: AddressLike, _to: AddressLike, _amount: BigNumberish) => { bestPool_: string, amountReceived_: BigNumber }, ITestCurveSwaps>
}

let ITestCurveSwapsBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestCurveSwapsBytecode = '0x';
}

// prettier-ignore
export const ITestCurveSwaps = contract<ITestCurveSwaps>(ITestCurveSwapsBytecode)`
  function get_best_rate(address _from, address _to, uint256 _amount) view returns (address bestPool_, uint256 amountReceived_)
`;